import {NextIncomingMessage} from "next/dist/server/request-meta";

import {dev} from "../components/_common/_constants";

export const getHostWithProtocol = (req?: NextIncomingMessage): string => {
  if (req) {
    return `${dev ? "http" : "https"}://${req.headers.host}`;
  }
  return location.protocol + "//" + location.host;
};
